require('./insurancesActiveProducts.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');

// @ helpers
const { formatText } = require('core/i18n').i18n;

// @ constants
const { EURO_TEXT } = require('constants/index');
const { INSURANCES_TYPE: { MOBILE_NOT_RELATED } } = require('../../../insuranceConstants/insuranceRequestTypes')
const PATHS = {
    LANDING: '/myprofile/insurances',
    HOME_INSURANCE: '/myprofile/insurances/home/',
    MOBILE_INSURANCE: '/myprofile/insurances/mobile/'
};
const { text } = require('../../../insuranceConstants/insuranceActiveProducts');

// @ components
const InsurancesListCard = require('../insurancesListCard/insurancesListCard');

class InsurancesActiveProducts extends React.Component {
    constructor(props) {
        super(props);

        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    getLink(immInsurance) {
        let link;
        if (immInsurance.get('insuranceProductType') === MOBILE_NOT_RELATED) {
            link = `${PATHS.MOBILE_INSURANCE}${immInsurance.get('policyNumber')}`;
        } else {
            link = `${PATHS.HOME_INSURANCE}${immInsurance.get('policyNumber')}`;
        }
        return link;
    }

    getMortgageInsurance(contractNumber) {
        const { immLoans } = this.props;
        const mortgageList = immLoans.get('byId');

        const currentMortgage = mortgageList.find(mortgage => mortgage.get('newContractNumber') === contractNumber)

        return currentMortgage ? {
            description: `${text().DESCRIPTION_MORTGAGE_INSURANCE}`,
            link: '/myprofile/loans-mortgages/loans/' + currentMortgage.get('loanId'),
            title: currentMortgage.get('alias'),
        } : null;
    }

    getInsurances() {
        const { immInsurances } = this.props;

        const insurances = immInsurances.map(immInsurance => {
            const insuranceProductType = immInsurance.get("insuranceProductType");
            const receipts = immInsurance.get('receipt');

            const lastAmount = receipts.map(receipt => receipt.get('totalAmount'));
            const amount = lastAmount.toArray()[0];
            const contractNumber = immInsurance.getIn(["complementaryInformation", 'mortgage', 'contractNumber']);
            const mortgage = contractNumber ? this.getMortgageInsurance(contractNumber) : null;

            if (insuranceProductType === MOBILE_NOT_RELATED) {
                return {
                    amount: amount,
                    currency: EURO_TEXT,
                    link: this.getLink(immInsurance),
                    mortgage: mortgage,
                    title: `${text().MOBILE_INSURANCE}`,
                    subtitle: text().PAYMENT.ANNUAL
                };
            }

            return {
                amount,
                currency: EURO_TEXT,
                link: `${PATHS[immInsurance.get('productDesc')]}${immInsurance.get('policyNumber')}`,
                mortgage: mortgage,
                title: text()[immInsurance.get('productDesc')],
                subtitle: text().PAYMENT[receipts.getIn([0, 'paymentType'])]
            };
        });

        return insurances.toJS();
    }

    render() {
        const {
            error,
            expanded,
            handleErrorRetry,
            handleLinkClick,
            hasOpenInsurances,
            id,
            title,
        } = this.props;

        const insurances = this.getInsurances();
        let extraLink;

        if (!hasOpenInsurances) {
            extraLink = {
                handleClick: handleLinkClick,
                text: formatText('insuranceLanding-otherInsurancesLink').toUpperCase(),
            };
        }

        const columns = [
            { title: formatText('insuranceLanding-activeInsuranceDescription'), className: 'col-sm-6' },
            { title: formatText('insuranceLanding-activeInsurancePaymentType'), className: 'col-sm-4' },
            { title: formatText('insuranceLanding-activeInsuranceAmount'), className: 'col-sm-2' }
        ];

        let hasError = false;
        let errorText;
        if (error) {
            hasError = true;

            if (error.getIn(['error', 'status'])) {
                errorText = formatText('insuranceLanding-errorMessage');
            } else {
                errorText = formatText('common-lostConnection');
            }
        }

        return (
            <section className="insurances-active-products">
                <InsurancesListCard
                    id={id}
                    icon="icon-insurances-badge"
                    amount={insurances.length}
                    cards={insurances}
                    title={title}
                    expanded={expanded}
                    extraLink={extraLink}
                    columns={columns}
                    error={hasError}
                    errorText={errorText}
                    handleErrorRetry={handleErrorRetry}
                />
            </section>
        );
    }
}

InsurancesActiveProducts.propTypes = {
    error: PropTypes.object.isRequired,
    expanded: PropTypes.bool,
    handleErrorRetry: PropTypes.func.isRequired,
    handleLinkClick: PropTypes.func.isRequired,
    hasOpenInsurances: PropTypes.bool.isRequired,
    id: PropTypes.string,
    immInsurances: PropTypes.object.isRequired,
    immLoans: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired,
};

module.exports = InsurancesActiveProducts;
